export const FirebaseConfig = {
	"projectId": "nordicdriver-f8a86",
	"appId": "1:581416651613:web:e215db5339a4ef9c1036b4",
	"databaseURL": "https://nordicdriver-f8a86-default-rtdb.europe-west1.firebasedatabase.app",
	"storageBucket": "nordicdriver-f8a86.firebasestorage.app",
	"apiKey": "AIzaSyBqiBKbseOknG5AUVSowlrsmSZn64dK6A8",
	"authDomain": "nordicdriver-f8a86.firebaseapp.com",
	"messagingSenderId": "581416651613",
	"measurementId": "G-0BMYCRFV75",
	"projectNumber": "581416651613",
	"version": "2"
};